import { render, staticRenderFns } from "./SpotsPanel.global.vue?vue&type=template&id=4427cc04&lang=pug&"
import script from "./SpotsPanel.global.vue?vue&type=script&lang=ts&"
export * from "./SpotsPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports